// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__103rA","row":"Node_row__2Tw2z","label":"Node_label__2TfNv","footer":"Node_footer__8Roa3"};